module.exports = __webpack_public_path__ + "24da2f76bc4f63db9e3f635319cf0902.svg";